import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserPermission } from '../auth/enums/user-permission.enum';
import { QuestionnaireComponent } from './components/customer/components/questionnaire/questionnaire.component';
import { CifcViewComponent } from './components/cifc/cifc-view/cifc-view.component';
import { RoleGuard } from '../auth/guards/role.guard';
import { CanDeactivateGuard } from '../../../common-modules/guards/can-deactivate-guard.service';

const routes: Routes = [
    {
        path: 'browse',
        component: CifcViewComponent,
        canActivate: [RoleGuard],
        data: {
            title: $localize`Customer Questionnaire`,
            roles: [UserPermission.QuestionnaireQuestionWrite],
            subSection: 'service management',
            subSubSection: 'customer questionnaire',
        },
    },
    {
        path: 'questionnaire',
        component: QuestionnaireComponent,
        canActivate: [RoleGuard],
        data: {
            title: $localize`Customer Questionnaire`,
            roles: [UserPermission.QuestionnaireQuestionsRead, UserPermission.QuestionnaireQuestionWrite],
            subSection: 'service management',
            subSubSection: 'customer questionnaire',
        },
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path: 'questionnaire/:id',
        component: QuestionnaireComponent,
        canActivate: [RoleGuard],
        data: {
            title: $localize`Customer Questionnaire`,
            roles: [UserPermission.QuestionnaireQuestionWrite],
            subSection: 'service management',
            subSubSection: 'customer questionnaire',
        },
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'browse',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CustomerQuestionnaireRoutingModule {
    constructor() {}
}
